<template>
  <div class="pre-liner text-msg" v-html="autolinekr()">
    <!-- <auto-link :content="msg.text" embed safe></auto-link> -->
  </div>
</template>

<script>
import Autolinker from 'autolinker'
export default {
  components: {
  },
  props: {
    msg: {}
  },
  methods: {
    autolinekr () {
      var linkedText = Autolinker.link(this.msg.text, {})
      return linkedText
    }
  }
}
</script>

<style scoped>
.pre-liner{
  white-space: pre-line;
  width: 100%;
  overflow: auto;
}
</style>
